import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { PlotService } from '../../services/plot.service';
import { DynamicFormComponent } from '../dynamic-form/dynamic-form.component';
import { DynamicFormService, FormFieldConfig } from '../../services/dynamic-form-service.service';
import { EbwModalService } from '@ebw-monorepo/modal';
import { safeJsonParse } from '@ebw-monorepo/microservices-helpers/utils/parser';

class Template {
  id: string;
  title: string;
  properties: FormFieldConfig[];
  attributes: FormFieldConfig[];
}

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'ebw-plot-map',
  templateUrl: './plot-map.component.html',
  styleUrls: ['./plot-map.component.scss']
})
export class PlotMapComponent implements OnInit, OnDestroy {
  @ViewChild(DynamicFormComponent) dynamicForm: DynamicFormComponent;

  templateList: Template[];
  plotTitle: string;
  currentTemplate: Template;
  viewportRatio: number;

  constructor(private _plotService: PlotService, private _dynamicFormService: DynamicFormService, private _modalService: EbwModalService) {}

  ngOnInit(): void {
    this.templateList = safeJsonParse(sessionStorage.getItem('templates'), []);
  }

  changedSelectedTemplate() {
    const selectedTemplate = this.templateList.find((template) => template.id === this.currentTemplate.id);

    if (selectedTemplate) {
      const fieldsArray: FormFieldConfig[] = this.convertFieldsObjectToArray(selectedTemplate.properties);
      const viewScaleField = fieldsArray.find((f) => f.external_name === 'view_scale');
      if (viewScaleField) {
        viewScaleField.required = true;
        viewScaleField.editable = true;
        viewScaleField.default = null;
      }
      const attributeArray: FormFieldConfig[] = this.convertFieldsObjectToArray(selectedTemplate.attributes);
      this._dynamicFormService.setFormConfig('formPlot', fieldsArray, attributeArray);
      this.viewportRatio =
        selectedTemplate.properties['primary_viewport_width'].default / selectedTemplate.properties['primary_viewport_height'].default;

      this._plotService.discardSelection();
    }
  }

  onFormSubmit(formValue: any) {
    this.dynamicForm.resetForm();
  }

  selectAreaClick(): void {
    // se servissero i valori del form e se è valido
    if ((<any>this.currentTemplate.properties).view_scale) {
      if (!this.dynamicForm.getFormState().isValid) {
        this._modalService.openWarningModal({
          title: 'Attenzione',
          content: "Impostare valore della scala prima di selezionare l'area"
        });
        return;
      }
      this._plotService.selectArea({
        scale: parseInt(this.dynamicForm.getFormState().values.view_scale),
        width: (<any>this.currentTemplate.properties).primary_viewport_width.default,
        height: (<any>this.currentTemplate.properties).primary_viewport_height.default
      });
    } else {
      this._plotService.selectArea({ ratio: this.viewportRatio });
    }
  }

  convertFieldsObjectToArray(fields: FormFieldConfig[]): FormFieldConfig[] {
    return Object.keys(fields).map((key) => {
      const field = fields[key];
      return {
        external_name: key,
        type: field.type,
        default: field.default,
        editable: field.editable,
        enum_values: field?.enum_values
      };
    });
  }

  onSave() {
    if (!this.dynamicForm?.form?.valid) {
      this._modalService.openWarningModal({
        title: 'Attenzione',
        content: 'Campi obbligatori(*) non validi'
      });
    }
    let pdfSettings = this.dynamicForm.form.getRawValue();

    pdfSettings.layout_type = this.currentTemplate.title;
    pdfSettings.title = this.plotTitle;
    this._plotService.save(pdfSettings, this.currentTemplate);
  }

  private resetPlotTemplate() {
    // reset form values and validators
    if (this.dynamicForm) {
      this.dynamicForm.resetForm();
    }
    this.plotTitle = null;
    this.currentTemplate = null;
  }

  getIcon(): string {
    if ((<any>this.currentTemplate.properties).view_scale) {
      return 'ads_click';
    }

    return 'highlight_alt';
  }

  ngOnDestroy(): void {
    this.resetPlotTemplate();
  }
}
